export default "__VITE_ASSET__CNPkYEhh__"